import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import goalsApi from "../api/goalsApi";
import { PERFORMANCE_QUERY_KEYS } from "../constants/performanceConstants";

const useGoalOptions = () => {
  const goalsQuery = useQuery({
    queryKey: [PERFORMANCE_QUERY_KEYS.goals, "selector"],
    queryFn: () => goalsApi.listGoals({ page: 1, limit: 200 }),
  });

  const goals = useMemo(() => {
    const rows = goalsQuery.data?.data;
    return Array.isArray(rows) ? rows : [];
  }, [goalsQuery.data]);

  const goalOptions = useMemo(
    () =>
      goals.map((goal) => ({
        value: goal._id,
        label: `${goal.title} (${goal.status || "DRAFT"})`,
      })),
    [goals],
  );

  return {
    goals,
    goalOptions,
    isLoading: goalsQuery.isLoading,
  };
};

export default useGoalOptions;
